import { createContext, useContext, type ReactNode } from "react";
import { useStore } from "zustand";

import type { GameController } from "../game/controller";
import type { GameState } from "../game/types";

const GameContext = createContext<GameController | null>(null);

export function GameProvider({
  controller,
  children,
}: {
  controller: GameController;
  children: ReactNode;
}) {
  return <GameContext.Provider value={controller}>{children}</GameContext.Provider>;
}

export function useController(): GameController {
  const controller = useContext(GameContext);
  if (!controller) throw new Error("GameProvider не найден");
  return controller;
}

export function useGame<T>(selector: (state: GameState) => T): T {
  return useStore(useController().store, selector);
}
